import PropTypes from "prop-types";
import TextInput from "@shared/v2/TextInput";

const SaveSmartFilterFields = ({ filterName, onFilterNameChange }) => (
  <>
    <p className="tw-m-0 tw-text-14d tw-leading-[20px] tw-text-gray-75">
      Your current filters do not match up with any existing Smart Filter so we&rsquo;ll need to save a new
      one first. This new filter will be used to generate the recipient list. Give your Smart Filter a name,
      then click Next.
    </p>
    <TextInput
      label="Smart Filter Name"
      isRequired
      value={filterName}
      onChange={(e) => onFilterNameChange(e.target.value)}
      helperText="You can delete this Smart Filter later if you don't need it"
    />
  </>
);

SaveSmartFilterFields.propTypes = {
  filterName: PropTypes.string,
  onFilterNameChange: PropTypes.func,
};

SaveSmartFilterFields.defaultProps = {
  filterName: "",
  onFilterNameChange: () => {},
};

export default SaveSmartFilterFields;
